module.exports = __webpack_public_path__ + "components/rewards/christy/static/logo-e88e736aea3332c3a8714a2f0eca91db.jpg";